import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { currentUserService } from "@/infrastructure/services";
import { mapToCurrentUser } from "@/infrastructure/adapters/current-user/current-user.mapper";
import { CurrentUser } from "@/infrastructure/adapters/current-user/current-user.types";

/**
 * Query: Fetch current user data
 * Uses service layer - automatically uses mock or API based on service registry
 */
export const useCurrentUserQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.USER.FETCH_ME],
    queryFn: async (): Promise<CurrentUser> => {
      const response = await currentUserService.getMe();
      return mapToCurrentUser(response.data);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes - user data changes infrequently
    gcTime: 30 * 60 * 1000, // 30 minutes cache
  });
};
